import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {fetchPostData} from './api'; // Import your common API file
import './Login.css'; // Import custom styles for Login
import login_image from '../assets/logos/quick_hire.svg';

const Login = ({setIsAuthenticated}) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    setIsAuthenticated(false);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetchPostData('/api/login', {
                username, password,
            });
            if (response.status) {
                // Save the token in localStorage
                localStorage.setItem('token', response.token);
                localStorage.setItem('user_id', response.user_id);

                // Set authentication state
                setIsAuthenticated(true);

                // Redirect to the dashboard
                navigate('/dashboard');
            }
        } catch (error) {
            console.error('Login failed', error);
        }
    };

    return (<div className="container-fluid login-container">
            <div className="row">
                {/* Column for Image */}
                <div className="col-md-6 d-none d-md-block login-image"></div>

                {/* Column for Login Form */}
                <div className="col-md-6 d-flex align-items-center justify-content-center">
                    <div className="login-form">
                        <img src={login_image} alt="Logo" className="logo"/> {/* Replace with your logo path */}
                        <h2 className="text-center">Login</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Username"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>);
};

export default Login;
